import React from 'react'
import agent from '../agent'
import LogList from './widgets/LogList';
import { connect } from 'react-redux'
import Pager from 'react-pager'
import {
  LOG_LIST_PAGE_LOADED,
  LOG_LIST_NEXT_PAGE_LOADED,
  LOG_LIST_PAGE_UNLOADED
} from '../constants/actionTypes'


const mapStateToProps = state => ({
  ...state.log,
  appName: state.common.appName,
  token: state.common.token
});

const mapDispatchToProps = dispatch => ({
  onLoad: (payload, pageIndex) =>
    dispatch({ type: LOG_LIST_PAGE_LOADED, payload, currentPage: pageIndex }),
  onLoadNextPage: (payload, pageIndex) => {
    dispatch({ type: LOG_LIST_NEXT_PAGE_LOADED, payload, currentPage: pageIndex })
  },
  onUnload: () =>
    dispatch({ type: LOG_LIST_PAGE_UNLOADED })
});

class Logs extends React.Component {
  componentWillMount() {
    const pageIndex = 1;
    this.props.onLoad(agent.Logs.all(pageIndex), pageIndex);
  }

  componentWillUnmount() {
    this.props.onUnload();
  }
  handlePageChanged(newPage) {
    //start page = 0
    const pageIndex = newPage + 1;
    this.props.onLoadNextPage(agent.Logs.all(pageIndex), pageIndex);
  }
  render() {
    const current = this.props.currentPage - 1
    return (
      <div class='pane'>
        <h1>Logs list</h1>
        <LogList logs={this.props.logs} loading={this.props.loading} />
        {
          this.props.logs && this.props.logs.length > 0 ?
            <Pager
              total={this.props.totalPage || 0}
              current={this.props.currentPage - 1}
              visiblePages={7}
              titles={{ first: '<<', last: '>>' }}
              onPageChanged={this.handlePageChanged.bind(this)}
            />
            : null
        }
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Logs);



// WEBPACK FOOTER //
// ./src/components/Logs.js